import { formatStatus } from '../../utils/api'

const NONE = 'None'
const NOT_RECORDED = 'Not recorded, check the item'
const ACCESSORY_ID = /^[a-z0-9_]+$/

// photography_queue.accessories is a JSON array of labels for most rows. An
// entry can be a raw id instead ("remote_control"), and an older row can hold
// plain text. A row with no value at all (Repairs, Issue Trades) means nobody
// could record accessories, which is not the same as the tester ticking none.
// Display-only: the stored value is untouched.
export function photographyAccessoriesLabel(accessories) {
  const recorded = parseAccessories(accessories)
  if (!recorded) return NOT_RECORDED
  return recorded.length > 0 ? recorded.map(accessoryLabel).join(', ') : NONE
}

// The recorded accessories as a list of text, or null when none were recorded.
function parseAccessories(accessories) {
  if (!accessories) return null
  try {
    const parsed = JSON.parse(accessories)
    if (Array.isArray(parsed)) return parsed.filter(isText)
    return isText(parsed) ? [parsed] : null
  } catch {
    return [accessories]
  }
}

function isText(value) {
  return typeof value === 'string' && value.trim() !== ''
}

function accessoryLabel(accessory) {
  return ACCESSORY_ID.test(accessory) ? formatStatus(accessory) : accessory
}
